module.exports = __webpack_public_path__ + "static/bg-home-f4769748362fca807dc57581a622f13c.jpg";